import { render, staticRenderFns } from "./arinvfrm.vue?vue&type=template&id=dbbd8e4c"
import script from "./arinvfrm.vue?vue&type=script&lang=js"
export * from "./arinvfrm.vue?vue&type=script&lang=js"
import style0 from "./arinvfrm.vue?vue&type=style&index=0&id=dbbd8e4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports